import { createAction, props } from '@ngrx/store';
import { RestApiError, SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { GetUserDetail_user } from '../../user-details/queries/generated/GetUserDetail';
import { UserPreferenceDetailFormValue } from '../models/user-preference-detail-form';
import { UserPreferenceDetailSaveEvent } from '../models/user-preference-detail-form-submit-event';
import { UserPreferenceDetailSaveModel } from '../models/user-preference-detail-save.model';

export const loadUser = createAction(
   '[User Preference Detail] Load User Preference Detail',
   props<{ userId: number }>()
);
export const loadUserSuccess = createAction(
   '[API] Load User Preference Detail Success',
   props<{ user: GetUserDetail_user }>()
);
export const loadUserFailure = createAction('[API] Load User Preference Detail Failure', props<SingleGraphError>());
export const loadCurrentUserId = createAction(
   '[User Preference Detail] Load Current UserId',
   props<{ userId: number }>()
);

export const saveUserPreferenceDetail = createAction(
   '[User Preference Detail] Save',
   props<UserPreferenceDetailSaveEvent>()
);
export const saveUserPreferenceDetailSuccess = createAction(
   '[User Preference Detail] Save Success',
   props<{
      effectiveUserPreferences: UserPreferenceDetailFormValue;
      userPreferenceSubmitValue: UserPreferenceDetailSaveModel;
   }>()
);
export const saveUserPreferenceDetailFailure = createAction(
   '[User Preference Detail] Save Failure',
   props<RestApiError>()
);

export const resetUserPreferenceForm = createAction('[User Preference Detail] Form Reset');
